(function(win) {
  'use strict';

  var listeners = [],
  doc = win.document,
  MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
  observer;

  function ready(selector, fn) {
      listeners.push({
          selector: selector,
          fn: fn
      });
      if (!observer) {
          // Watch for changes in the document
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
              childList: true,
              subtree: true
          });
      }
      // Check if the element is currently in the DOM
      check();
  }

  function check() {
      // Check the DOM for elements matching a stored selector
      for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
          listener = listeners[i];
          // Query for elements matching the specified selector
          elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
              element = elements[j];
              // Make sure the callback isn't invoked with the
              // same element more than once
              if (!element.ready) {
                  element.ready = true;
                  // Invoke the callback with the element
                  listener.fn.call(element, element);
              }
          }
      }
  }

  // Expose `ready`
  win.ready = ready;

})(this);


// Touch

var body = document.getElementsByTagName('body')[0];
if ( !("ontouchstart" in body) ) {
    body.className += (body.className?" ":"") + "no-touch";
} else {
    body.className += (body.className?" ":"") + "has-touch";
}


// Menu hover
/*
if ( !("ontouchstart" in body) ) {
  let items = document.querySelector(".list-menu--inline").querySelectorAll("details:not(.shop-by-brand):not(.links)");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {

      const myTimeout = setTimeout(hover, 100);

      function hover() {

        item.setAttribute("open", true);
        item.querySelector(".header__subdropdown").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

      }

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        clearTimeout(myTimeout);
      });

    });
  });
}
*/

// Menu Expand
/*
document.querySelectorAll(".header__subdropdown > div > ul > li").forEach(function(element){
  element.addEventListener("click", function(event){

    //console.log('test')

    document.querySelectorAll(".header__subdropdown > div > ul > li details:not(.shop-by-brand):not(.links)").forEach(function(element){
      element.removeAttribute("open");
    });

  });
});
*/


// Related Slider
/*
ready('#related-product-grid .grid__item', function(element) {
  var relatedSlider = document.getElementById('related-product-grid');
  if ( relatedSlider ){
    var flkty = new Flickity( relatedSlider, {
      // options
      groupCells: true,
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      pauseAutoPlayOnHover: false
    });
  }
});*/


/* Testimonials Slider */

var testimonialSlider = document.querySelector('.testimonials-wrapper');
if ( testimonialSlider ){
    var flkty = new Flickity( testimonialSlider, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: 8000,
      pauseAutoPlayOnHover: false
    });
}


/* USP Slider */

var uspSlider = document.querySelectorAll('.usp-wrapper');
if ( uspSlider ){
  uspSlider.forEach(slider => {
    var flkty = new Flickity( slider, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 3000,
      watchCSS: true,
      pauseAutoPlayOnHover: false
    });
  });
}


/* Product Gallery Slider 

var gallerySlider = document.querySelector('.product__media-list');
if ( gallerySlider ){
    var flkty = new Flickity( gallerySlider, {
      // options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: true
    });
}*/

function groupValue(){
    let groupInput = document.getElementById("group-id-input");
    if (groupInput) {
      groupInput.value = Date.now().toString() + 
                        Math.random().toString(36).substring(2,7);
    }
}
if ( document.querySelector('product-info .product') ){
    groupValue();
}

if ( document.querySelector('product-info .product') ){

$(document).ready(function(){

  $(document).on('click','label[for="custom-no"]',function(event){
    $('.custom-size-input input').val('');
  });
  $(document).on('click','.custom-size-input .field',function(event){
    $(this).removeClass('red');
  });

  // ----- Colour Dropdown
  $(document).on('click','.custom-colour .select',function(event){ 
    $(this).parent().toggleClass('open');
    $('.custom-colour .select').removeClass('red');
    $('.custom-colour .form__label span').remove('');
    event.stopPropagation();
  });
  $(document).on('click','body',function(){ 
    $('.custom-colour').removeClass('open');;
  });
  $(document).on('click','.custom-colour .select__dropdown',function(event){ 
    event.stopPropagation();
  }); 
  $(document).on('click','.custom-colour .colour__field label',function(){
    var value = $(this).attr('title');
    $('.custom-colour .select__select').text(value);
    $('.colour__field.custom input').val('');
    $('.colour-match__field.custom input').val('');
  }); 

  $(document).on('keyup','.colour__field.custom input',function(){
    var value = $(this).val();
    $('.custom-colour .select__select').text('#'+value);

    $('.custom-colour .colour__field input').each(function() {
      $(this).prop('checked', false);
    });
    $('.colour-match__field.custom input').val('');
  });

  $(document).on('keyup','.colour-match__field.custom input',function(){
    var value = $(this).val();
    $('.custom-colour .select__select').text(value);

    $('.custom-colour .colour__field input').each(function() {
      $(this).prop('checked', false);
    });
    $('.colour__field.custom input').val('');
  });

  $(document).on('click','.product .product-form__submit',function(event){

    var customSize = $('.custom-size-input input').val();
    if ( $('#custom-yes').is(':checked') && customSize === '' ) {
      event.preventDefault();
      $('.custom-size-input .field').addClass('red');
    }

    if ( $('variant-selects select[name="options[Finish]"]').val() === 'Painted' || $('.custom-colour.product-form__input').hasClass('tikkurila-paint') ) {

      var colourValue = $('.custom-colour .select__select').text();
      //|| (colourValue.length < 7)
      if ( (colourValue == 'Select...') || (colourValue == '') || (colourValue == '#') ) {
        event.preventDefault();
      }
      if ( (colourValue == 'Select...') || (colourValue == '') || (colourValue == '#') ) {
        $('.custom-colour .form__label span').remove();
        $('.custom-colour .select').addClass('red');
        $('<span>Please select</span>').prependTo('.custom-colour .form__label');
      }

    } else {
      $('.colour__field.custom input').val('');
      $('.colour-match__field.custom input').val('');
      $('.custom-colour .colour__field input').each(function() {
        $(this).prop('checked', false);
      });
      $('.custom-colour .select__select').text('Select...');
    }
    /*
    if ( colourValue.length < 7 ) {
      $('.custom-colour .form__label span').remove();
      $('.custom-colour .select').addClass('red');
      $('<span>Please input valid hex</span>').prependTo('.custom-colour .form__label');
    }
    */
  });


  // ----- Add ons

  // Get shopify product price on load
  var productPrice = $('.price__container .price-item--regular').text().trim().replace("£", "");
  $('.custom-total .value').text(productPrice);

  // Observe shopify product price change
  var targetPrice = document.querySelector('.product-prices');
  // Create an observer instance.
  var observerPrice = new MutationObserver(function(mutations) {
      // Run total price calculcation function
      calculateTotalPrice();
  });
  // Pass in the target node, as well as the observer options.
  observerPrice.observe(targetPrice, {
      //attributes:    true,
      //characterData: true,
      childList:     true
  });

  // Detect custom variant select change
  $(document).on('change','.custom-variant-selects select',function(){

    // Display image for variant when selected
    $(this).closest('.product-form__input').find('.select__images div').css('display','none');
    var optionSelected = $(this).find('option:selected').data('option-value-id');
    $(this).closest('.product-form__input').find('.select__images div[data-id="'+optionSelected+'"]').css('display','inline-flex');

    // Run total price calculcation function
    calculateTotalPrice();

  });

  // Total price calculcation function
  function calculateTotalPrice(){
    var productPriceEl = $('.price__container .price-item--regular').text().trim().replace("£", "").replace(",", "");
    var productPriceNumber = parseInt(productPriceEl);

    var addOnPrices = [];
    $('.custom-variant-selects select').each(function(){
      var selectedOptionPrice = $(this).find('option:selected').data('price');
      if ( selectedOptionPrice ){
        var optionPrice = selectedOptionPrice.trim().replace("£", "").replace(",", "");
        addOnPrices.push(optionPrice);
      }
    });
    addOnPricesArray = addOnPrices.map(Number);
    console.log(addOnPricesArray);

    let sum = 0;
    for (let i = 0; i < addOnPricesArray.length; i++) {
      sum += addOnPricesArray[i];
    }
    let sumTotal = sum + productPriceNumber;
    console.log(sumTotal);

    $('.custom-total .value').text(sumTotal.toFixed(2));
  };
  
  // Add accessories to cart
  //$(document).on('click','.product-form__submit',function(){
  $(document).on('submit', 'form[action="/cart/add"]', function(e) {

    let colourValue = $('.custom-colour .select__select').text();

    const finish = $('variant-selects select[name="options[Finish]"]').val();

    const customSizeChecked = $('#custom-yes').is(':checked');
    const customSize = $('.custom-size-input input').val();

    
    if (
      !(customSizeChecked && !customSize) && // skip if custom size checked but empty
      (finish !== 'Painted' || !['Select...', '', '#'].includes(colourValue)) // accessories logic
    ) {
      addAccessories();
    }

    /*
    if ( customSizeChecked && !customSize ) {

    } else{

      if (finish === 'Painted' && !['Select...', '', '#'].includes(colourValue)) {
        addAccessories();
      } else if (finish !== 'Painted') {
        addAccessories();
      }

    }
    */
    
    function addAccessories(){

      let IDs = [];
      let qty = $('.product-form__quantity .quantity__input').val();

      $('.custom-variant-selects select').each(function(){
        let optionID = $(this).find('option:selected').data('option-value-id');
        if ( optionID ) {
          IDs.push(optionID);
        }
      });

      /*
      var handleID = $('.select-handle').find('option:selected').data('option-value-id');
      if ( handleID ) {
        IDs.push(handleID);
      }
      */

      let groupId = document.getElementById("group-id-input")?.value;

      if ( IDs.length > 0 ) {

        setTimeout(() => {
          $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: qty,
            id: IDs,
            properties: {
              _group_id: groupId
            }
          },
          dataType: 'json', 
          success: function (data) { 
            console.log(data.quantity);
      
            $.ajax({
                type: 'GET',
                url: '/cart.json',
                dataType: 'json',
                success: function(data) { 
                    var item_count = data.item_count;
                    console.log(item_count);
                    $('.cart-count-bubble > span').text(item_count);
                }
            });
            
          } 
          });
        }, "1800");

      }

    }

    setTimeout(function(){
      groupValue();
    }, 2000);
  });


  /*
  document.addEventListener('submit', function(e) {

    const form = e.target;

    if (!form.matches('form[action="/cart/add"]')) return;

    // Wait for Dawn's AJAX add to finish
    setTimeout(() => {
      addAccessories();
    }, 700);

  });*/
  
});

}

